<template>
  <div class="main-layout">
    <div class="layout-content">
      <u-table
        :headers="returnHeader"
        :items="items"
        :mobileBreakpoint="900"
        :offsetHeight="0"
        :showSelect="false"
        :loading="loading"
        :pagination="pagination"
        itemKey="id"
        @onChangePagination="onChangePagination"
        @dbclickRow="openDialogViewer"
      >
        <template v-slot:header>
          <!-- // # layer 1 -->
          <div class="header-card">
            <div class="title-page">รายการที่นำเข้า</div>
            <div>
              <v-btn
                color="#20409C"
                class="btn-upload"
                rounded
                @click="actionClickXrayType()"
              >
                <!-- Activator slot -->
                <v-icon class="pr-3" color="white"
                  >mdi-cloud-upload-outline</v-icon
                >อัปโหลดฟิล์ม
              </v-btn>
              <!-- อัปโหลดฟิล์ม X-ray -->
              <!-- <div
                v-if="checkSelectTypeUpload == 'selectedCTScan'"
              >
                CT Scan
              </div> -->
            </div>
          </div>
          <!-- layer 2.2 -->
          <div>
            <v-tabs v-model="tabSelectType">
              <v-tab
                v-for="item in itemForTypeTab"
                :key="item.name"
                :disabled="item.valid"
                @click="totalTabSelectType(item.value)"
                style="font-weight: 500; font-size: 16px"
              >
                {{ item.name }}
                <!-- <span :class="item.value === checkStateClickTab ? 'counter-typetab-click' : 'counter-typetab-nonclick'">
                    {{countTotolBox}}
                  </span> -->
              </v-tab>
            </v-tabs>
          </div>
          <!-- // # layer 2 -->
          <!-- <div class="d-flex justify-space-between mt-5"> -->
          <div class="layout-total-box" style="width: 100%">
            <div
              class="total-box"
              v-for="(film, idx) in itemsFilm.item"
              :key="`${idx}-${film}`"
            >
              <!-- box 1 -->
              <div
                class="d-flex justify-space-between px-3"
                style="width: 100%"
              >
                <div class="d-flex">
                  <v-img class="size-img-box mr-5" :src="film.image"></v-img>
                  <div class="mr-5 d-flex align-center">{{ film.title }}</div>
                </div>
                <div class="font-weight: 700; font-size: 20px;">
                  <v-progress-circular
                    v-if="loadingSummaryBox"
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                  <span v-else class="pr-2" :style="`color: ${film.color}`">
                    {{ itemSummary[film.key] }}
                  </span>
                  <!-- <span class="pr-2" :style="`color : ${item.color} font-weight: 700; font-size: 20px;`">{{ item.value }}</span> -->
                  <span>{{ film.unit }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- // # layer 3.1 -->
          <!-- // # layer 3 -->
          <v-row no-gutters class="mt-5 section-three">
            <v-col class="d-flex" cols="12" md="6">
              <v-col cols="6">
                <v-text-field
                  v-model="keyword"
                  name="name"
                  outlined
                  dense
                  append-icon="mdi-magnify"
                  placeholder="ค้นหา"
                  label="ค้นหา"
                  hide-details
                  rounded
                  @keyup.enter="init()"
                  @click:append="init()"
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="6">
                <div class="filter-text">
                <div><v-icon>mdi-filter-outline</v-icon></div><a
                  class="px-3"
                  style="text-decoration: underline;"
                >ตัวกรอง</a>
              </div>
              </v-col> -->
            </v-col>
            <v-col class="d-flex justify-end" cols="12" md="6">
              <!-- สองปุ่ม -->
              <div class="d-flex align-center">
                <!-- ปุ่ม Refrash -->
                <!-- <v-badge
                  v-if="countRefreshBtn > 0"
                  color="error"
                  offset-x="20"
                  offset-y="10"
                >
                  <v-btn class="width-btn" :disabled="!refresh" @click="setTimeOutRefeshBtn">
                    <v-icon size="x-large" style="color: #20409c"
                      >mdi-refresh</v-icon
                    >
                    <div style="color: #20409c">รีเฟรช</div>
                  </v-btn>
                </v-badge>
                <v-btn v-else class="width-btn" disabled>
                  <v-icon size="x-large">mdi-refresh</v-icon>รีเฟรช
                </v-btn> -->
                <v-btn
                  class="width-btn ml-2 color-btn-expor-refresh"
                  @click="exportExcel"
                  :disabled="checkStateClickTab == 'CT-SCAN'"
                >
                  <v-icon color="color-btn-expor-refresh"
                    >mdi-tray-arrow-up</v-icon
                  >
                  <div>Export</div>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </template>
        <template v-slot:[`item.number`]="{ item }">
          {{
            pagination.row * pagination.page -
            pagination.row +
            (items.indexOf(item) + 1)
          }}
        </template>
        <template v-slot:[`item.create_date`]="{ item }">
          {{ item.create_date | BE_DD_MM_YYYY_HH_MM }}
        </template>

        <template v-slot:[`item.resource.da`]="{ item }">
          <span v-if="item.resource.da != ''">{{
            item.resource.da | BE_DD_MM_YYYY_HH_MM_GMT
          }}</span>
          <span v-else>-</span>
        </template>

        <template v-slot:[`item.resource.pn`]="{ item }">
          <span class="fix-overflow-ellipsis">{{
            item.resource.pn != "" ? item.resource.pn : "-"
          }}</span>
        </template>

        <template v-slot:[`item.resource.po`]="{ item }">
          {{ item.resource.po != "" ? item.resource.po : "-" }}
        </template>

        <!-- FIX 2024-06-28  ทำให้ทุก Status เป็น รอยืนยันผล-->
        <template v-slot:[`item.status`]="{}">
          <div
            small
            class="my-1 d-flex align-center"
            :style="`color : ${colorStatusChip(false)};white-space: nowrap;`"
          >
            <v-icon
              class="mx-2"
              :style="`color : ${colorStatusChip(
                false
              )}; width: 18px; height: 18px;`"
            >
              <!-- {{ colorStatusIcon(item.items[0].status) }} -->
              {{ colorStatusIcon(false) }}
            </v-icon>
            {{ textStatusChip(false) }}
            <!-- {{ textStatusChip(item.items[0].status) }} -->
          </div>
        </template>

        <template
          v-slot:[`item.result`]="{ item }"
          class="fix-overflow-ellipsis"
        >
          <v-chip
            v-if="!item.items[0].status"
            outlined
            small
            :color="colorStatusChip(item.items[0].status)"
            class="my-1"
          >
            {{ textStatusChip(item.items[0].status) }}
          </v-chip>
          <div
            v-if="item.items[0].status"
            style="display: flex; justify-content: center"
          >
            <div
              v-for="item in item.items[0]?.processes"
              :key="item.process_id"
            >
              <v-chip
                v-if="item.results.length !== 0"
                small
                class="my-1"
                :color="item.results.length > 0 ? 'warning' : 'success'"
              >
                {{ item.name.substring(0, 3) + "..." }}
              </v-chip>
            </div>
            <v-chip
              v-if="statusNormal(item.items[0].processes)"
              small
              color="success"
              class="my-1"
            >
              ไม่พบโรค
            </v-chip>
          </div>
        </template>

        <template v-slot:[`item.detail`]="{ item }">
          <div class="d-inline-flex">
            <!-- รีเซต -->
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  icon
                  fab
                  x-small
                  dark
                  color="primary"
                  style="
                    width: 28px;
                    height: 28px;
                    background: #ffffff;
                    box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08),
                      0px 0.5px 2px rgba(96, 97, 112, 0.16);
                    border-radius: 8px;
                    margin: 8px;
                  "
                  @click="RestartProcess(item)"
                >
                  <v-icon>mdi-cached</v-icon>
                </v-btn>
                <!-- <u style="font-weight: 400; font-size: 14px; color: #20409C; cursor: pointer;" @click="openDialogViewer(item)">รายละเอียด</u> -->
              </template>
              <span>รีเฟรช</span>
            </v-tooltip>
            <!-- ดูรายละเอียด -->
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  icon
                  fab
                  x-small
                  dark
                  color="primary"
                  @click="openDialogViewer(item)"
                  style="
                    width: 28px;
                    height: 28px;
                    background: #ffffff;
                    box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08),
                      0px 0.5px 2px rgba(96, 97, 112, 0.16);
                    border-radius: 8px;
                    margin: 8px;
                  "
                >
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
                <!-- <u style="font-weight: 400; font-size: 14px; color: #20409C; cursor: pointer;" @click="openDialogViewer(item)">รายละเอียด</u> -->
              </template>
              <span>ดูรายละเอียด</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:[`item.annotation`]="{ item }">
          <!-- รีเซต -->
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                icon
                fab
                x-small
                dark
                color="primary"
                style="
                  width: 28px;
                  height: 28px;
                  background: #ffffff;
                  box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08),
                    0px 0.5px 2px rgba(96, 97, 112, 0.16);
                  border-radius: 8px;
                  margin: 8px;
                "
                @click="openDialogLabel(item)"
              >
                <v-icon>mdi-draw</v-icon>
              </v-btn>
              <!-- <u style="font-weight: 400; font-size: 14px; color: #20409C; cursor: pointer;" @click="openDialogViewer(item)">รายละเอียด</u> -->
            </template>
            <span>Label Annotation</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.actions`]="{}">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                icon
                fab
                x-small
                color="primary"
                disabled
                @click="openDialogViewer(item)"
              >
                <v-icon>mdi-file-download</v-icon>
              </v-btn>
            </template>
            <span>ดาวน์โหลด</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                icon
                fab
                x-small
                color="third"
                disabled
              >
                <v-icon>mdi-printer</v-icon>
              </v-btn>
            </template>
            <span>ปริ้น</span>
          </v-tooltip>
          <v-tooltip top v-if="priorityUser === 0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                icon
                fab
                x-small
                disabled
                color="error"
              >
                <v-icon>mdi-delete-forever</v-icon>
              </v-btn>
            </template>
            <span>ลบ</span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.review`]="{ item }">
          <v-chip
            outlined
            small
            :color="
              returnStatusWriteReview(item.reviews) == false
                ? 'warning'
                : 'primary'
            "
            class="my-1"
          >
            {{
              returnStatusWriteReview(item.reviews) == false
                ? "ยังไม่เขียน"
                : "เขียนแล้ว"
            }}
          </v-chip>
        </template>
      </u-table>
    </div>

    <!-- Dialog UploadFile -->
    <v-dialog
      v-model="dialogUploadXray"
      max-width="1157"
      persistent
      class="green"
    >
      <!-- <v-hover v-slot="{ hover }"> -->
      <v-card elevation="15">
        <!-- <v-card class="UploadFileXrayCard "> -->
        <v-card-title
          style="color: #20409c; font-size: 24px; font-weight: normal"
          class="pl-8 d-flex justify-space-between"
        >
          เลือกประเภท File {{ this.checkStateClickTab }}
          <!-- {{checkSelectTypeUpload}} -->
          <v-icon @click="dialogUploadXray = false,serviceType='',serviceID=[] " color="#C4C4C4"
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-card-subtitle class="mt-1 pl-8 d-flex justify-space-between">
          <div class="d-flex" style="font-weight: 400; font-size: 16px">
            กรุณาเลือกประเภทที่ต้องการอัปโหลดไฟล์
          </div>
          <!-- <div
            class="d-flex align-center"
            style="font-weight: 400; font-size: 16px"
          >
            <div>
              <v-img
                style="width: 24px; height: 24px; margin-right: 5px"
                src="@/assets/images/xraypage/quantityFilmXray.png"
              ></v-img>
            </div>
            จำนวนฟิล์มที่ใช้แล้วทั้งหมด 0 ฟิล์ม
          </div> -->
        </v-card-subtitle>
        <div class="type-file-xray" v-if="!stateProgressBar">

          <v-row>
            <v-col
              class="type-xray-block ma-3"
              v-for="(item, index) in itemFormtTypXrayBox"
              :key="index"
              style="padding: 0"
            >
              <v-hover>
                <template v-slot:default="{ hover }">
                  <v-card style="height: 100%; border-radius: inherit">
                    <v-fade-transition>
                      <v-overlay
                        v-show="hover || item.detail.length == 0"
                        absolute
                        :color="`${
                          !item.detail.length ? '#9E9E9E' : 'primary'
                        }`"
                      >
                        <!-- <v-btn
                        >
                          See more info
                        </v-btn> -->
                        <!-- <v-icon>mdi-cloud-upload</v-icon>อัปโหลดไฟล์ -->
                        <div
                          v-show="item.detail.length > 0"
                          class="custom-file-upload"
                        >
                          <div>
                            <div class="d-flex justify-center">
                              <v-icon style="font-size: 60px"
                                >mdi-cloud-upload</v-icon
                              >
                            </div>
                            <div
                              style="font-weight: 700; font-size: 20px"
                              class="my-4"
                            >
                              อัปโหลดไฟล์
                            </div>
                            <div>
                              <label
                                class="custom-btn-file-upload"
                                @click="stateProgressBar = true , serviceType = item.type, serviceID = item.serviceId"
                              >
                                <div>เลือกไฟล์</div>
                              </label>
                            </div>

                            <!-- <DragDropUploadXrayVue
                            v-model="files"
                            accept=".dcm"
                            @input="CreateDataTable"
                          ></DragDropUploadXrayVue> -->
                          </div>
                        </div>
                        <div
                          v-if="item.detail.length == 0"
                          style="font-weight: 900; font-size: 28px"
                        >
                          coming soon
                        </div>
                      </v-overlay>
                    </v-fade-transition>
                    <div class="title-fileXrayBox">
                      {{ item.title }}
                    </div>
                    <div
                      style="padding: 5px; width: 100%"
                      class="d-flex justify-center"
                    >
                      <div
                        class="d-flex justify-center"
                        style="width: 80px; height: 80px"
                      >
                        <v-img :src="item.pathImg"></v-img>
                      </div>
                    </div>
                    <div class="d-flex mt-5">
                      <v-row no-gutters justify="start" class="mx-3 d-flex">
                        <div
                          v-for="(itemDetail, index) in item.detail"
                          :key="index"
                          style="width: 100%"
                        >
                          <v-col class="text-center d-flex">
                            <div>
                              <v-img
                                style="width: 16px; height: 16px"
                                src="@/assets/images/xraypage/img-check-green.png"
                              ></v-img>
                            </div>
                            <div
                              style="font-weight: 400; font-size: 16px"
                              class="mx-3"
                            >
                              {{ itemDetail.name }}
                            </div>
                          </v-col>
                        </div>
                      </v-row>
                    </div>
                  </v-card>
                </template>
              </v-hover>
            </v-col>
          </v-row>
        </div>

        <div v-else class="mx-5">
          <UploadFeature
            :hospital_id="hospital_id"
            :type="type"
            :seriesId="series_id"
            :services = "serviceID"
          />
          <!-- <div style="width: 100%;" class="d-flex justify-center">
            <v-btn class="width-btn" @click="stateProgressBar=false">
            <div style="color: #20409c">กลับ</div>
          </v-btn>
          </div> -->
        </div>
        <v-card-text class="d-flex justify-end mt-5">
          * หมายเหตุ สามารถ Upload PNG, JPG, DCM. ขนาดไฟล์ไม่เกิน 1 GB ต่อไฟล์
        </v-card-text>

        <!-- NOTE ACTION BUTTON & VIEW FILE TO UPLOAD -->
        <!-- <v-row
          justify="start"
          align="center"
          dense
          style="height: 100%"
        >
          <v-col
            cols="6"
            sm="3"
            md="2"
          >
            <v-btn
              :disabled="files.length <= 0"
              color="error"
              block
              @click="Reset"
            >ลบทั้งหมด</v-btn>
          </v-col>
          <v-col
            cols="6"
            sm="3"
            md="2"
          >
            <v-btn
              :disabled="files.length <= 0"
              color="primary"
              block
              @click="upload"
            >เริ่มตรวจหาโรค</v-btn>
          </v-col>
        </v-row> -->
      </v-card>
      <!-- </v-hover> -->
    </v-dialog>
    <v-dialog v-model="dialogExport" scrollable max-width="800" persistent>
      <v-card>
        <v-card-title
          style="color: #0075ff; font-size: 24px; font-weight: normal"
          class="px-5"
        >
          <v-icon class="mr-2" color="#0075FF">mdi-file-export</v-icon>ส่งออก
          Excel
        </v-card-title>

        <v-divider></v-divider>
        <v-card-title class="px-5 font-weight-regular">
          เลือกโรค
          <v-spacer></v-spacer>
          <v-btn
            depressed
            x-small
            fab
            @click="(expandService = !expandService), (selectService = [])"
          >
            <v-icon>{{ expandService ? "mdi-minus" : "mdi-plus" }}</v-icon>
          </v-btn>
        </v-card-title>
        <v-expand-transition>
          <v-card-text v-show="expandService">
            <v-select
              multiple
              :items="serviceName"
              v-model="selectService"
              placeholder="กรุณาเลือกโรคที่ต้องการ"
              outlined
              dense
              required
              hide-details
              chips
            ></v-select>
          </v-card-text>
        </v-expand-transition>
        <v-divider></v-divider>
        <v-card-title class="px-5 font-weight-regular">
          เลือกรายการอัปโหลด
          <v-spacer></v-spacer>
          <v-btn depressed x-small fab @click="clickExpandHistory()">
            <v-icon>{{ expandHistory ? "mdi-minus" : "mdi-plus" }}</v-icon>
          </v-btn>
        </v-card-title>
        <v-expand-transition>
          <v-card-text v-show="expandHistory" class="px-0">
            <span>
              <v-row class="ma-0">
                <v-col>
                  <u-date-picker
                    isBE
                    v-model="exportStartDate"
                    :max="exportEndDate"
                    format="DD-MM-YYYY"
                    format_output="YYYY-MM-DD"
                    label="วันเริ่มต้น"
                    :rules="[Rule.noInPut]"
                    @input="
                      (paginationExportTable.page = 1), getHistoryExport()
                    "
                  >
                  </u-date-picker>
                </v-col>
                <v-col>
                  <u-date-picker
                    isBE
                    :min="exportStartDate"
                    v-model="exportEndDate"
                    format="DD-MM-YYYY"
                    format_output="YYYY-MM-DD"
                    label="วันสิ้นสุด"
                    :rules="[Rule.noInPut]"
                    @input="
                      (paginationExportTable.page = 1), getHistoryExport()
                    "
                  >
                  </u-date-picker>
                </v-col>
              </v-row>
            </span>
            <v-row align="center" class="px-5" no-gutters>
              <v-col cols="1">
                <!-- <v-checkbox
                  :disabled="!selectHistory.length"
                  :input-value="selectHistory.length"
                  @change="selectHistory = Object.assign([]), historyExportNew = Object.assign([])"
                ></v-checkbox> -->
              </v-col>
              <v-col cols="2"> วันที่อัปโหลด </v-col>
              <v-col cols="2" class="text-center"> ชื่อไฟล์ที่อัปโหลด </v-col>
              <v-col cols="2" class="text-center"> ชื่อผู้ป่วย </v-col>
              <v-col cols="2" class="text-center"> H/N </v-col>
              <v-col cols="3" class="text-center"> ผลลัพธ์ </v-col>
            </v-row>
            <v-divider></v-divider>
            <u-infinity-scroll
              v-model="historyExport"
              :increase.sync="increase"
              :current.sync="current"
              itemKey="id"
              :loading="loadingExport"
              maxHeight="32vh"
              style="scrollbar-width: thin !important"
            >
              <template v-slot:body="{ item }">
                <v-card
                  :color="selectHistory.includes(item.job_id) ? '#f5f5f5' : ''"
                  :id="item.job_id"
                  v-intersect="onIntersect"
                >
                  <v-row align="center" class="px-5" no-gutters>
                    <v-col cols="1">
                      <v-checkbox
                        v-model="item.stateExport"
                        :value="item.job_id"
                        @change="changeListHistoryExport(item)"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="2">
                      {{ item.create_date | BE_DD_MM_YYYY }}
                    </v-col>
                    <v-col cols="2" class="text-center">
                      {{
                        item.resource.old_filename != ""
                          ? item.resource.old_filename
                          : "-"
                      }}
                    </v-col>
                    <v-col cols="2" class="text-center">
                      {{ item.resource.pn != "" ? item.resource.pn : "-" }}
                    </v-col>
                    <v-col cols="2" class="text-center">
                      {{ item.resource.po != "" ? item.resource.po : "-" }}
                    </v-col>
                    <v-col cols="3" class="text-center">
                      <v-chip
                        v-if="!item.items[0].status"
                        outlined
                        small
                        :color="colorStatusChip(item.items[0].status)"
                      >
                        {{ textStatusChip(item.items[0].status) }}
                      </v-chip>
                      <div
                        v-if="item.items[0].status"
                        style="display: flex; justify-content: center"
                      >
                        <div
                          v-for="item in item.items[0]?.processes"
                          :key="item.process_id"
                        >
                          <v-chip
                            v-if="item.results.length !== 0"
                            small
                            class="my-1"
                            :color="
                              item.results.length > 0 ? 'warning' : 'success'
                            "
                          >
                            {{ item.name.substring(0, 3) + "..." }}
                          </v-chip>
                        </div>
                        <v-chip
                          v-if="statusNormal(item.items[0].processes)"
                          small
                          color="success"
                          class="my-1"
                        >
                          ไม่พบโรค
                        </v-chip>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </template>
            </u-infinity-scroll>
            <v-divider></v-divider>
            <div class="d-flex justify-end my-2">
              <span class="pt-2 mr-2 pagination-text">Rows Per Page : </span>
              <v-select
                v-model="paginationExportTable.row"
                :items="[10, 20, 30]"
                placeholder="Standard"
                hide-details
                dense
                class="row-per-page"
                @change="
                  (paginationExportTable.page = 1), onChangePaginationExport()
                "
              ></v-select>
              <!-- หน้า/หน้าทั้งหมด -->
              <span v-if="paginationExportTable.total === 0" class="pt-2 mx-2"
                >0-0 of 0</span
              >
              <span v-else class="pt-2 mr-2 ml-2">
                {{
                  paginationExportTable.row * (paginationExportTable.page - 1) +
                  1
                }}
                -
                {{
                  paginationExportTable.row * (paginationExportTable.page - 1) +
                    paginationExportTable.row >=
                  paginationExportTable.total
                    ? paginationExportTable.total
                    : paginationExportTable.row *
                        (paginationExportTable.page - 1) +
                      paginationExportTable.row
                }}
                of {{ paginationExportTable.total }}</span
              >
              <!-- ปุ่มซ้าย -->
              <v-btn
                icon
                :disabled="paginationExportTable.page === 1"
                @click="
                  paginationExportTable.page--, onChangePaginationExport()
                "
                ><v-icon icon color="primary">mdi-chevron-left</v-icon></v-btn
              >
              <!-- ปุ่มขวา -->
              <v-btn
                icon
                :disabled="
                  paginationExportTable.page ===
                    Math.ceil(
                      paginationExportTable.total / paginationExportTable.row
                    ) ||
                  Math.ceil(
                    paginationExportTable.total / paginationExportTable.row
                  ) === 0
                "
                class="btn-pagination-default color-btn"
                @click="
                  paginationExportTable.page++, onChangePaginationExport()
                "
                ><v-icon color="primary">mdi-chevron-right</v-icon></v-btn
              >
            </div>
          </v-card-text>
        </v-expand-transition>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#dc3545"
            @click="dialogExport = false"
            depressed
            large
            dark
            width="15%"
          >
            ยกเลิก
          </v-btn>
          <v-btn
            color="#0075ff"
            @click="mapJobIdForExportExcelAdvance"
            depressed
            large
            dark
            width="15%"
          >
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <u-card-form
      :title="formTitle"
      :subtitle="formSubTitle"
      icon="mdi-clipboard-text"
      widthDialog="1000"
      ref="form"
      v-model="dialog"
    >
      <template v-slot:form>
        <div class="d-flex pb-3">
          <div class="title-card">
            H/N :
            {{ detailItem.resource.po != "" ? detailItem.resource.po : "-" }}
          </div>
          <v-spacer></v-spacer>
          <!-- <div class="title-card">สถานะ :</div> -->
        </div>
        <div class="detal-card pb-3">
          ชื่อผู้ป่วย :
          {{ detailItem.resource.pn != "" ? detailItem.resource.pn : "-" }}
        </div>
        <div class="detal-card pb-3">
          วันที่อัปโหลด :
          {{
            $moment(detailItem.start_date).add(543, "year").format("DD-MM-YYYY")
          }}
        </div>
        <div class="detal-card pb-3">
          วันที่ X-ray :
          {{
            detailItem.resource.da != ""
              ? $moment(detailItem.resource.da)
                  .add(543, "year")
                  .format("DD-MM-YYYY")
              : "-"
          }}
        </div>
        <div class="detal-card pb-3">
          ชื่อไฟล์ : {{ detailItem.resource.filename }}
        </div>
        <div class="detal-card pb-3">
          consult : {{ returnConsult(consultJob) }}
          <!-- <span v-for="(dataConsult, i) in consultJob" :key="i"
            >{{ dataConsult.first_name }} {{ dataConsult.last_name
            }}<span v-if="i + 1 !== consultJob.length">, </span></span
          > -->
        </div>
        <v-btn
          @click="openFormConsoult()"
          small
          :dark="detailItem.status"
          color="primary"
          :disabled="!detailItem.status"
          ><v-icon class="mr-2">mdi-note-edit</v-icon>ส่งconsult</v-btn
        >
        <div style="display: flex" class="mb-n3 mt-4">
          <div class="detal-card mr-1">โรคที่พบ :</div>
          <div>
            <v-radio-group v-model="disease" row class="layout-radio">
              <v-radio
                v-for="items in detailItem.processes"
                :key="items.process_id"
                :label="items.name"
                :value="items"
                class=""
              ></v-radio>
            </v-radio-group>
          </div>
        </div>
        <v-divider class="mb-5"></v-divider>
        <div
          style="display: flex"
          v-if="
            disease.results !== null &&
            disease.results !== undefined &&
            disease.results.length !== 0
          "
        >
          <div class="">*เลือกกล่องที่ต้องการดูผล :</div>
          <div style="display: flex; flex-wrap: wrap">
            <div
              v-for="item in disease.results"
              :key="item.result_id"
              style="width: fit-content"
              class="mx-2"
            >
              <v-checkbox
                v-model="checkBoxDisease[item.name]"
                :label="`confident : ${item.confident}%`"
                :value="item"
                class="pa-0 ma-0"
              ></v-checkbox>
            </div>
          </div>
        </div>

        <v-alert text dense :color="colorIconStatus" border="left">
          {{ disease.status }}
        </v-alert>
        <div
          v-if="
            disease.results !== null &&
            disease.results !== undefined &&
            disease.results.length !== 0
          "
        >
          <squareOnImage
            :box="checkBoxDisease[disease.name]"
            :srcImage="detailItem.resource.file"
          />
        </div>
        <div
          v-if="disease.results !== undefined && disease.results.length === 0"
        >
          <v-img :src="detailItem.resource.file"></v-img>
        </div>
        <div class="detal-card mt-5">
          <div class="primary--text mb-3">เขียนข้อเสนอแนะ</div>
          <div>
            <u>{{ userInfo.first_name }} {{ userInfo.last_name }}</u>
          </div>
          <v-textarea
            v-model="review"
            auto-grow
            outlined
            rows="5"
            row-height="15"
            class="mt-3 mb-n3"
            :disabled="disabledReview"
          ></v-textarea>
          <div class="mb-5 d-flex">
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!detailItem.status"
              :dark="detailItem.status"
              color="primary"
              v-if="disabledReview"
              @click="(disabledReview = false), (reviewOld = review)"
            >
              {{
                ststusReview === "add" ? "เขียนข้อเสนอแนะ" : "แก้ไขข้อเสนอแนะ"
              }}
            </v-btn>
            <v-btn
              :disabled="!detailItem.status"
              :dark="detailItem.status"
              :loading="loading"
              class="mx-1"
              color="primary"
              v-if="!disabledReview"
              @click="updateReview()"
            >
              บันทึก
            </v-btn>
            <v-btn
              :disabled="!detailItem.status"
              :dark="detailItem.status"
              :loading="loading"
              color="error"
              v-if="!disabledReview"
              @click="closeUpdateReview()"
            >
              ยกเลิก
            </v-btn>
          </div>
        </div>
        <v-divider class="mb-5"></v-divider>
        <div class="detal-card">
          <div class="my-5">ข้อเสนอแนะอื่น</div>
          <div
            v-if="detailItem.reviews.length === 1 && ststusReview === 'edit'"
          >
            -
          </div>
          <div v-if="detailItem.reviews.length === 0">-</div>
          <div v-for="item in detailItem.reviews" :key="item.review_id">
            <div v-if="item.create_by !== userInfo.user_id">
              <u>
                <span>{{ item.first_name }} {{ item.last_name }}</span>
                <span v-if="item.first_name === '' && item.last_name === ''"
                  >Unknow</span
                >
                <span v-if="item.type === 'consult'"> : consult</span></u
              >
              <v-textarea
                :value="
                  item.description !== ''
                    ? item.description
                    : 'ยังไม่เขียนข้อเสนอแนะ'
                "
                auto-grow
                outlined
                rows="5"
                row-height="15"
                class="mt-3"
                disabled
              ></v-textarea>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:actions="{}">
        <v-row>
          <v-col
            ><v-btn :loading="loading" block color="error" @click="close"
              >ปิด</v-btn
            ></v-col
          >
        </v-row>
      </template>
    </u-card-form>

    <u-card-form
      title="ส่งconsult"
      subtitle=""
      icon="mdi-note-edit"
      widthDialog="500"
      v-model="dialogConsult"
    >
      <template v-slot:form>
        <div><span>เลือกผู้ที่ต้องการส่งให้ consult</span></div>
        <v-select
          v-model="consult"
          :items="itemConsult"
          :item-text="(item) => item.first_name + ' ' + item.last_name"
          item-value="user_id"
          placeholder="กรุณาเลือกผู้ที่ต้องการส่งให้ consult"
          :loading="loading"
          chips
          dense
          multiple
          outlined
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index <= 1">
              <span>{{ item.first_name }} {{ item.last_name }}</span>
            </v-chip>
            <span v-if="index === 2" class="grey--text text-caption">
              (+{{ consult.length - 2 }} others)
            </span>
          </template>
        </v-select>
      </template>
      <template v-slot:actions="{}">
        <v-row>
          <v-col>
            <v-btn
              block
              color="primary"
              :loading="loading"
              @click="UpdaeteConsult()"
            >
              บันทึก
            </v-btn>
          </v-col>
          <v-col>
            <v-btn
              block
              color="error"
              :loading="loading"
              @click="
                closeDialgConsult(), matchConsult(detailItem.users, itemConsult)
              "
            >
              ยกเลิก
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </u-card-form>

    <u-advance-history
      v-if="advanceDialog"
      v-model="advanceDialog"
      :src="advanceDialogImage"
      :processes="advanceDialogProcess"
      :detail-item="advanceDialogDetailObject"
      :items.sync="itemViews"
      :hospital_id="hospital_id"
      :checkStateClickTab="checkStateClickTab"
      @createComment="onCreateComment"
      @createSubComment="oncreateSubComment"
      @updateComment="onUpdateComment"
      @deleteMainComment="onDeleteMainComment"
      @deleteSubComment="onDeleteSubComment"
    >
    </u-advance-history>

    <u-advance-label
      v-if="advanceLabelDialog"
      v-model="advanceLabelDialog"
      :src="advanceDialogImage"
      :processes="advanceDialogProcess"
      :detail-item="advanceDialogDetailObject"
      :items.sync="itemViews"
      :hospital_id="hospital_id"
      :annotation.sync="currentAnnotation"
      @updateDraw="onUpdateAnnotation"
    >
    </u-advance-label>
  </div>
</template>
<script>
import squareOnImage from '../squareOnImage.vue'
import { uuid } from 'vue-uuid'
import { mapMutations, mapGetters } from 'vuex'
// import DragDropUploadXrayVue from '../Uploads/DragDropUploadXray.vue'
import UploadFeature from '../Uploads/UploadFeature.vue'

export default {
  components: {
    squareOnImage,
    UploadFeature
    // DragDropUploadXrayVue
  },
  props: {
    hospital_id: {
      type: String
    },
    priorityUser: {
      type: Number,
      default: null
    },
    userInfo: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      exportStartDate: this.$moment().format('YYYY-MM-DD'),
      exportEndDate: this.$moment().format('YYYY-MM-DD'),

      loadingSummaryBox: false,
      currentLabelSeriesId: null,
      advanceLabelDialog: false,
      advanceDialog: false,
      advanceDialogDetailObject: {},
      advanceDialogImage: '',
      advanceDialogProcess: [],
      advanceDialogBoxs: [],
      w: 0,
      h: 0,

      refresh: false,
      countRefreshBtn: 0,
      tempGetUploadBackground: [],
      pagination: {
        total: 0,
        page: 1,
        row: 10
      },
      loading: false,
      dialog: false,
      NameComponent: 'ประวัติ',
      keyword: '',
      dialogStartDate: false,
      startDate: null,
      // startDate: '2024-07-05',
      dialogEndDate: false,
      endDate: null,
      // endDate: '2024-07-06',
      serviceName: [],
      headers: [
        {
          text: 'ลำดับ',
          align: 'center',
          sortable: false,
          value: 'number'
        },
        {
          text: 'ชื่อผู้ป่วย',
          align: 'left',
          sortable: false,
          value: 'resource.pn'
        },
        {
          text: 'H/N',
          align: 'left',
          value: 'resource.po',
          sortable: false
        },
        // {
        //   text: 'type',
        //   align: 'center',
        //   sortable: false,
        //   value: 'type'
        // },
        // {
        //   text: 'ประเภท',
        //   align: 'center',
        //   sortable: false,
        //   value: 'items[0].type'
        // },
        {
          text: 'Filename',
          align: 'left',
          value: 'resource.old_filename',
          sortable: false
        },
        // {
        //   text: 'สถานะรายการ',
        //   align: 'center',
        //   value: 'status',
        //   sortable: false
        // },
        {
          text: 'ผลลัพธ์',
          value: 'result',
          sortable: false,
          align: 'center'
        },
        {
          text: 'วัน/เวลา ที่อัปโหลด',
          value: 'create_date',
          sortable: false,
          align: 'center'
        },
        {
          text: 'วัน/เวลา X-ray',
          value: 'resource.da',
          sortable: false,
          align: 'center'
        },
        // {
        //   text: 'จำนวน slide',
        //   value: 'count',
        //   sortable: false,
        //   align: 'center'
        // },
        // {
        //   text: 'Label',
        //   value: 'annotation',
        //   sortable: false,
        //   align: 'center'
        // },
        {
          text: 'รายละเอียด',
          value: 'detail',
          sortable: false,
          align: 'center'
        }
        // {
        //   text: 'ข้อเสนอแนะ',
        //   value: 'review',
        //   sortable: false,
        //   align: 'center'
        // },
        // {
        //   text: 'จัดการ',
        //   value: 'actions',
        //   sortable: false,
        //   align: 'center',
        //   width: '150px'
        // }
      ],
      items: [],
      result: 'all',
      itemResult: [
        {
          val: 'abnormal',
          text: 'ตรวจพบ'
        },
        {
          val: 'normal',
          text: 'ปกติ'
        },
        {
          val: 'all',
          text: 'ทั้งหมด'
        }
      ],
      detailItem: {
        resource: {
          po: '',
          da: ''
        },
        processes: [],
        create_date: '',
        reviews: []
      },
      // show processes
      disease: {},
      checkBoxDisease: {},
      /// -----formConsult---------///
      consult: [],
      itemConsult: [],
      dialogConsult: false,
      consultJob: [],
      review: '',
      review_id: '',
      ststusReview: '', // update or add
      disabledReview: true,
      reviewOld: '',

      // --------- form export ---------
      dialogExport: false,
      expandService: false,
      selectService: [],
      expandHistory: false,
      historyExport: [],
      historyExportNew: [],
      selectHistory: [],
      increase: 10,
      current: 1,
      limit: 0,
      loadingExport: false,
      itemViews: [],
      // ------For Upload File-----------
      itemSummary: {
        total_upload: 0,
        total_upload_confirm: 0,
        total_upload_pending: 0,
        total_user: 0,
        total_user_pending: 0
      },
      itemsFilm: {
        title: 'การใช้งาน',
        item: [
          {
            image: require('@/assets/images/xraypage/img_box_X-ray01.png'),
            title: 'รายการทั้งหมด',
            key: 'total_upload',
            unit: 'เคส',
            color: '#016DB6'
          },

          // FIX ปิดไปก่อน
          // {
          //   image: require('@/assets/images/xraypage/img_box_X-ray02.png'),
          //   title: 'รอยืนยันผล',
          //   // key: 'total_upload_pending',
          //   key: 'total_upload',
          //   unit: 'เคส',
          //   color: '#FEA53F'
          // },
          {
            image: require('@/assets/images/xraypage/img_box_X-ray03.png'),
            title: 'ยืนยันผลวินิจฉัย',
            key: 'total_upload_confirm',
            unit: 'เคส',
            color: '#37C976'
          }
        ]
      },
      itemsUser: {
        title: 'ผู้ใช้งาน',
        item: [
          {
            image: require('@/assets/images/xraypage/userAll.png'),
            title: 'ผู้ใช้งานทั้งหมด',
            key: 'total_user',
            unit: 'คน'
          },
          {
            image: require('@/assets/images/xraypage/userWaitApprove.png'),
            title: 'ผู้ใช้งานรออนุมัติ',
            key: 'total_user',
            unit: 'คน'
          },
          {
            title: 'ยืนยันผลวินิจฉัย',
            Image: require('@/assets/images/xraypage/img_box_X-ray03.png'),
            Key: 'total_upload_confirm',
            unit: 'เคส'
          }
        ]
      },
      itemsUpload: [
        {
          title: 'X-ray',
          icon: 'mdi-play-box-multiple',
          action: 'selectedXray'
        },
        {
          title: 'CT Scan',
          icon: 'mdi-logout',
          action: 'selectedCTScan'
        }
        // {
        //   title: 'MRI',
        //   icon: 'mdi-logout',
        //   action: 'selectedMRI'
        // }
      ],
      checkSelectTypeUpload: '',
      itemsForSelect: ['ทั้งหมด', 'เคสด่วน'],
      stateSelectUploadXray: false,
      dialogUploadXray: false,

      // form type file x-ray
      itemFormtTypXrayBox: [
        {
          title: 'สมอง',
          value: 'brain',
          pathImg: require('@/assets/images/xraypage/img-brain.png'),
          detail: [],
          type: 'brain',
          serviceId: []
        },
        {
          title: 'ทรวงอก',
          value: 'breast',
          pathImg: require('@/assets/images/xraypage/img-breast.png'),
          detail: [],
          type: 'chest',
          serviceId: []
        },
        {
          title: 'ดวงตา',
          value: 'eye',
          pathImg: require('@/assets/images/xraypage/img-eye.png'),
          detail: [
          ],
          type: 'retina',
          serviceId: []
        }
      ],
      // uploade
      selectedFile: null,
      isSelecting: false,
      layer3: false,

      // For Upload
      files: FileList,
      tmpFiles: FileList,
      diagnosisList: [],
      type: '',
      series_id: '',
      allname: [],
      statusUpload: true,
      itemsForUpload: [
        // {
        //   index: 0,
        //   size: '',
        //   fileNae: '',
        //   proress: 0
        // }
      ],
      tmpItems: [],
      itemForTable: [
        {
          count: 86,
          series_id: 'd7e09439-ef7f-49fc-8496-418572880184',
          resource: {
            filename: '',
            old_filename: '',
            filetype: 'image/jpeg',
            path: 'cxrV4/original/dicom/',
            size: 347902,
            width: 415,
            height: 415,
            file: '',
            status: true,
            pn: 'nattid phawandee',
            po: '673999',
            da: '2024-01-29 07:33',
            series_description: 'NC AX 2 MM',
            series_number: 450,
            instance_number: 40,
            description: ''
          }
        }
      ],
      itemsMockApi: [
        {
          _id: '661f71e6871398edee988771',
          job_id: 'ce27cd01-c2fa-4f7c-b949-78a48745cdbb',
          hospital_id: '04169ee0-b279-4c3a-8af9-1ede0f2ac2a6',
          resource: {
            filename: 'ce27cd01-c2fa-4f7c-b949-78a48745cdbb.jpg',
            old_filename: '40.dcm',
            filetype: 'image/jpeg',
            path: 'cxrV4/original/dicom/',
            size: 347902,
            width: 415,
            height: 415,
            file: '',
            status: true,
            pn: 'SINGTO SAISAMAO',
            po: '673999',
            da: '2024-01-29 07:33',
            series_description: 'NC AX 2 MM',
            series_number: 450,
            instance_number: 40,
            description: ''
          },

          processes: [
            {
              process_id: 'ca823184-b9a4-43b6-b9e2-37216ef85936',
              status: 'success',
              tag: 'process_ai_cardiomegaly',
              name: 'Cardiomegaly',
              description: '',
              result: [],
              create_date: '2024-04-17T06:53:26.558+0000',
              update_date: '2024-04-17T06:53:26.558+0000'
            }
          ],
          reviews: [],
          comments: [],
          status: true,
          create_by: 'd409a8cf-08e0-4fbb-b5ae-10cc501ca0a3',
          description: '',
          series_id: 'd7e09439-ef7f-49fc-8496-418572880184',
          type: 'series',
          callback: '',
          ref_id: '',
          create_date: '2024-04-17T06:53:26.480+0000',
          update_date: '2024-04-17T06:53:28.030+0000'
        }
      ],
      tabSelectType: null,
      itemForTypeTab: [
        { name: 'X-ray', value: 'xray', valid: false },
        { name: 'CT-Scan', value: 'CTscan', valid: true }
        // { name: 'รายการ X-ray ดวงตา', value: 'MRI' }
      ],
      menuTabType: 'single',
      checkStateClickTab: 'X-RAY',
      countTotolBox: '',
      // switch: [],
      // wait: false,
      // selected: [],
      // switch1: false,
      // scrollInvoked: 0,

      // files: [],
      // isSelecting: false,
      currentAnnotation: null,
      stateProgressBar: false,
      joinJobIdExport: '',
      paginationExportTable: {
        total: 0,
        page: 1,
        row: 10
      },
      // service type
      serviceType: '',
      serviceID: []
    }
  },
  computed: {
    ...mapGetters(['getUploadBackground']),
    returnHeader () {
      // FIX ปิด Feature Label สำหรับ Xray
      // NOTE 0 == Series , 1 == Single
      if (!this.tabSelectType) return this.headers
      else {
        return this.headers.filter(
          (e) => e.text !== 'Label' && e.text !== 'จำนวน slide'
        )
      }
    },
    formTitle () {
      return 'รายละเอียดทั้งหมด'
    },
    formSubTitle () {
      return ''
    },
    colorIconStatus () {
      if (this.disease.status === 'pending') return 'primary'
      else if (this.disease.status === 'success') return 'success'
      else return 'red'
    },
    maxStartDate () {
      if (this.endDate) return this.endDate
      return this.$moment().format('YYYY-MM-DD')
    },
    maxDate () {
      return this.$moment().format('YYYY-MM-DD')
    },
    changeFormatStartDate () {
      return this.startDate
        ? this.$moment(this.startDate).add(543, 'years').format('DD-MM-YYYY')
        : ''
    },
    changeFormatEndDate () {
      return this.endDate
        ? this.$moment(this.endDate).add(543, 'years').format('DD-MM-YYYY')
        : ''
    }
    // buttonText () {
    //   return this.selectedFile ? this.selectedFile.name : this.defaultButtonText
    // }
  },
  watch: {
    // async dialogExport (val) {
    //   if (val) {
    //     this.expandService = false
    //     this.selectService = this.serviceName
    //     this.expandHistory = false
    //     this.historyExport = Object.assign([])
    //     this.selectHistory = Object.assign([])
    //     // this.current = 1
    //     const payload = {
    //       page: this.current,
    //       row: this.increase,
    //       hospital_id: this.hospital_id,
    //       keyword: this.keyword,
    //       diagnosis: this.result === 'all' ? '' : this.result,
    //       start_date: !this.startDate
    //         ? ''
    //         : this.$moment(this.startDate).format('YYYY-MM-DD') + ' 00:00:00',
    //       end_date: !this.endDate
    //         ? ''
    //         : this.$moment(this.endDate).format('YYYY-MM-DD') + ' 23:59:59',
    //       time_zone: 'Asia/Bangkok'
    //     }
    //     const res = await this.getHistoryForTable(payload)
    //     if (res.status) {
    //       this.historyExport = res.data.data
    //       this.limit = res.data.pagination.total
    //     } else {
    //       this.antmessage.error(res.message)
    //     }
    //   }
    // },
    switch1 (newValue) {
      if (newValue) {
        this.selected = this.allname.map((e) => e.service_id)
      } else {
        this.selected = []
      }
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
    files (x) {
      this.pagination.total = this.itemsForUpload.length
    }
  },
  created () {
    this.initService()
    this.init()
    this.initHospitalStatus()
    // this.getHistoryExport()

    // this.$EventBus.$on('upload-progress', (val) => {
    //   this.itemsForUpload
    //     .filter((x) => x.id === val.id)
    //     .forEach((x) => {
    //       x.progress = val.progress
    //     })
    //   if (this.itemsForUpload.every((x) => x.progress === 100)) {
    //     this.notification.success({
    //       message: 'อัปโหลดไฟล์ทั้งหมดเสร็จสิ้น',
    //       description: `อัปโหลดไฟล์ทั้งหมด ${this.getUploadBackground.length} ไฟล์ เสร็จสิ้น`,
    //       placement: 'bottomRight'
    //     })
    //     // this.$swal({
    //     //   toast: true,
    //     //   allowEnterKey: false,
    //     //   title: 'สำเร็จ',
    //     //   position: 'bottom-end',
    //     //   showClass: {
    //     //     popup: `
    //     //     animate__animated
    //     //     animate__fadeInRight
    //     //     animate__faster
    //     //   `
    //     //   },
    //     //   hideClass: {
    //     //     popup: `
    //     //     animate__animated
    //     //     animate__fadeOutRight
    //     //     animate__faster
    //     //   `
    //     //   },
    //     //   grow: 'row',
    //     //   // text: 'อัปโหลดไฟล์ทั้งหมดเสร็จสิ้น',
    //     //   text: `อัปโหลดไฟล์ทั้งหมด ${this.getUploadBackground.length} ไฟล์ เสร็จสิ้น`,
    //     //   icon: 'success',
    //     //   showConfirmButton: false,
    //     //   showCancelButton: false,
    //     //   timer: 5000
    //     // })
    //     // setTimeout(() => {
    //     //   this.$emit('toHistory')
    //     // }, 3000)
    //   }
    // })
  },
  mounted () {
    this.$websocket.$on('upload:job', (e) => {
      this.refresh = true
      // แก้กรณีที่ มีอัปโหลดเพิ่ม แล้วยังไม่กด refresh
      // tempGetUploadBackground.push()
      this.countRefreshBtn = this.getUploadBackground.length
      const coutFile = this.files.length * 200
      // this.tempGetUploadBackground = Object.assign([])
      // for (const item of this.getUploadBackground) {
      //   this.tempGetUploadBackground.push({
      //     id: item.id,
      //     size: item.size,
      //     name: item.name,
      //     progress: 0
      //   })
      // }
      setTimeout(() => {
        this.init()
        this.initHospitalStatus()
      }, coutFile)
    })

    // FIX WS
    this.$websocket.$on('update:job', (e) => {
      const data = JSON.parse(JSON.stringify(this.items))
      for (let index = 0; index < data.length; index++) {
        const c = data[index].items.filter((i) => i.job_id === e.job_id)
        if (c.length > 0) {
          data[index].resource = JSON.parse(JSON.stringify(e.resource))
        }
        // if (e.job_id === data[index].resource.job_id) {
        //   data[index].resource = JSON.parse(JSON.stringify(e))
        // }
      }
      this.items = JSON.parse(JSON.stringify(data))
      // if
      // this.detailAll()
    })
  },
  methods: {
    async initService () {
      const payload = {
        hospital_id: this.hospital_id
      }
      const res = await this.getHospitalPackageForUpload(payload)
      if (res.status) {
        for (let index = 0; index < this.itemFormtTypXrayBox.length; index++) {
          for (let index2 = 0; index2 < res.data.length; index2++) {
            if (this.itemFormtTypXrayBox[index].type === res.data[index2].type) {
              this.itemFormtTypXrayBox[index].detail.push(res.data[index2])
              this.itemFormtTypXrayBox[index].serviceId.push(res.data[index2].service_id)
            }
          }
        }

        for (let index3 = 0; index3 < res.data.length; index3++) {
          if (res.data[index3].type === undefined || res.data[index3].type === '') {
            this.itemFormtTypXrayBox[1].detail.push(res.data[index3])
            this.itemFormtTypXrayBox[1].serviceId.push(res.data[index3].service_id)
          }
        }
      } else {
        this.antmessage.error(res.message)
      }
    },
    async onUpdateAnnotation (val) {
      // let seriesId = ''
      const hospitalId = this.$route.params.hospital_id
      // if (this.items.length > 0) {
      //   seriesId = this.items[0].series_id
      // }
      await this.updateAnnotation(hospitalId, this.currentLabelSeriesId, val)
      // console.log('🚀 ~ async onUpdateAnnotation ~ res:', res)
    },
    async openDialogLabel (val) {
      this.currentLabelSeriesId = val.items[0].series_id
      // TODO Clear Default Data
      this.itemViews = JSON.parse(JSON.stringify([]))
      // TODO Is "single" mode

      // VERSON 1
      // for (let i = 0; i < val.items.length; i++) {
      //   this.itemViews.push({
      //     job_id: val.items[i].job_id,
      //     po: val.items[i].resource.po,
      //     pn: val.items[i].resource.pn,
      //     da: val.items[i].resource.da,
      //     create_date: val.items[i].create_date,
      //     create_by: val.items[i].create_by,
      //     type: val.items[i].type,
      //     series_id: val.items[i].series_id,
      //     resource: val.items[i].resource,
      //     src: this.imageUrl(val.items[i].resource.filename),
      //     processes: val.items[i].processes,
      //     adjusts: {
      //       brightness: 100,
      //       contrast: 100
      //     },
      //     comments: val.items[i].comments,
      //     dicom: this.dicomUrl(`${val.items[i].job_id}.dcm`)
      //   })
      // }
      // VERSION 2
      this.itemViews = val.items.map((item) => ({
        job_id: item.job_id,
        po: item.resource.po,
        pn: item.resource.pn,
        da: item.resource.da,
        create_date: item.create_date,
        create_by: item.create_by,
        type: item.type,
        series_id: item.series_id,
        resource: item.resource,
        src: this.imageUrl(item.resource.filename),
        processes: item.processes,
        adjusts: {
          brightness: 100,
          contrast: 100
        },
        comments: item.comments,
        dicom: this.dicomUrl(`${item.job_id}.dcm`)
      }))
      // TODO Get Annotation
      this.w = val.resource.width
      this.h = val.resource.height

      const hospitalId = this.$route.params.hospital_id

      // NOTE สำหรับ Reset Annotation
      this.currentAnnotation = null

      // NOTE สำหรับดึง Annotation จาก Backend
      this.currentAnnotation = await this.getAnnotationFromStore(
        hospitalId,
        this.currentLabelSeriesId
      )

      // NOTE สำหรับเรียกเปิด Dialog Label
      this.advanceLabelDialog = true
    },
    async getAnnotationFromStore (hospitalId, seriesId) {
      if (seriesId !== '' && hospitalId !== '') {
        const res = await this.getAnnotation(hospitalId, seriesId)
        if (res.status) {
          if (res.data.length > 0) {
            return await res.data[0].annotation
          }
        } else {
          this.notification.error({
            message: 'Error',
            description: res.message,
            placement: 'bottomRight'
          })
          return null
        }
      } else {
        this.notification.error({
          message: 'Error',
          description: 'not found hospitalId or seriesId',
          placement: 'bottomRight'
        })
        return null
      }
    },

    totalTabSelectType (val) {
      if (val === 'xray') {
        // Xray (ทรวงอก)
        this.menuTabType = 'single'
        this.checkStateClickTab = 'X-RAY'
        // this.checkSelectTypeUpload = 'breast'
      } else if (val === 'CTscan') {
        // CT สมอง
        this.menuTabType = 'series'
        this.checkStateClickTab = 'CT-SCAN'
        // this.checkSelectTypeUpload = 'brain'
        this.type = 'series'
      } else {
        // MRI (ดวงตา)
        this.menuTabType = 'single'
        this.checkStateClickTab = 'MRI'
      }
      // this.menuTabType = val
      this.init()
      this.initHospitalStatus()
    },
    actionClickXrayType () {
      // this.checkSelectTypeUpload = action
      // this.checkStateClickTab = 'CTscan'
      this.stateProgressBar = false
      if (this.checkStateClickTab === 'X-RAY') {
        // เปิด dialogUploadXray
        this.dialogUploadXray = true
        this.checkSelectTypeUpload = 'breast'
        this.type = 'single'
      } else if (this.checkStateClickTab === 'CT-SCAN') {
        this.dialogUploadXray = true
        this.checkSelectTypeUpload = 'brain'
        this.type = 'series'
      }
      // else if (action === 'selectedMRI') {
      //   this.dialogUploadXray = true
      //   this.checkSelectTypeUpload = 'eye'
      //   this.type = 'series'
      // }
    },
    RestartProcess (val) {
      let showStateRefrash = true
      val.items.forEach(async (i) => {
        const payload = {
          ...{ hospital_id: this.hospital_id, job_id: i.job_id }
        }
        const res = await this.restartProcessAIWithAccesstoken(payload)
        if (res.status) {
          showStateRefrash = true
        } else {
          showStateRefrash = false
          // this.antmessage.error(res.message)
        }
      })
      if (showStateRefrash) {
        this.notification.success({
          message: 'Restart process success',
          // description: 'dsfa',
          placement: 'bottomRight',
          duration: 3
        })
      } else {
        this.notification.error({
          message: 'error',
          // description: 'dsfa',
          placement: 'bottomRight',
          duration: 3
        })
      }
    },
    selectFile (e) {
      for (let i = 0; i < e.target.files.length; i++) {
        e.target.files[i].id = uuid.v4()
      }
      this.files = Array.from(this.files).concat(Array.from(e.target.files))
      // this.files = e.target.files
    },
    chechStateBtnUploadXrayFile () {
      this.stateSelectUploadXray = !this.stateSelectUploadXray
    },
    async onCreateComment (val) {
      const payload = {
        ...{ hospital_id: this.hospital_id },
        ...val
      }
      const res = await this.CreateJobComment(payload)
      if (res.status) {
        // FIX Update Update Comment
        const currentJobIndex = this.itemViews.findIndex(
          (e) => e.job_id === val.job_id
        )
        this.itemViews[currentJobIndex].comments.push(res.data)
      }
    },
    async oncreateSubComment (val) {
      const payload = {
        ...{ hospital_id: this.hospital_id },
        ...val
      }
      const res = await this.UpdateJobComment(payload)
      if (res.status) {
        // FIX Update Update Comment
        const currentJobIndex = this.itemViews.findIndex(
          (e) => e.job_id === val.job_id
        )
        console.log(currentJobIndex)
        // this.itemViews[currentJobIndex].comments.push(res.data)
      }
    },
    async onUpdateComment (val) {},
    async onDeleteMainComment (val) {
      const payload = {
        ...{ hospital_id: this.hospital_id },
        ...val
      }
      const res = await this.DeleteJobComment(payload)
      if (res.status) {
        // FIX Update Update Comment
        const currentJobIndex = this.itemViews.findIndex(
          (e) => e.job_id === val.job_id
        )
        console.log(currentJobIndex)
        // this.itemViews[currentJobIndex].comments.push(res.data)
      }
    },
    async onDeleteSubComment (val) {
      const payload = {
        ...{ hospital_id: this.hospital_id },
        ...val
      }
      const res = await this.UpdateJobComment(payload)
      if (res.status) {
        // FIX Update Update Comment
        const currentJobIndex = this.itemViews.findIndex(
          (e) => e.job_id === val.job_id
        )
        console.log(currentJobIndex)
        // this.itemViews[currentJobIndex].comments.push(res.data)
      }
    },
    async init () {
      this.loading = true
      this.refresh = false
      // เมื่อ click refresh set
      this.countRefreshBtn = 0
      // getUploadBackground
      // TODO ดึงชื่อ servive name ทั้งหมด สำหรับเลือกโรคเพื่อ export
      const resSrv = await this.getServiceForDropdown()
      if (resSrv.status) {
        this.serviceName = resSrv.data.map((e) => e.name)
      } else {
        this.antmessage.error(resSrv.message)
      }
      // TODO เป็น Function ที่ใช้ในการ initial ข้อมูลที่จะเอามาใส่ในตราง
      const payload = {
        page: this.pagination.page,
        row: this.pagination.row,
        hospital_id: this.hospital_id,
        keyword: this.keyword,
        diagnosis: this.result === 'all' ? '' : this.result,
        start_date: !this.startDate
          ? ''
          : this.$moment(this.startDate).format('YYYY-MM-DD') + ' 00:00:00',
        end_date: !this.endDate
          ? ''
          : this.$moment(this.endDate).format('YYYY-MM-DD') + ' 23:59:59',
        time_zone: 'Asia/Bangkok',
        type: this.menuTabType
      }
      const res = await this.getHistoryForTable(payload)
      this.loading = false
      if (res.status) {
        this.items = res.data.data
        // console.log(this.items)
        this.countTotolBox = res.data.pagination.total
        this.pagination = res.data.pagination
      } else {
        this.antmessage.error(res.message)
      }
    },
    async getsJobFromSeries (val) {
      // TODO เป็น Function สำหรับดึงข้อมูลผลการคัดกรองโรคแบบ Series โดย
      // TODO จะสามารถดึงได้มากที่สุด 100 รูป
      const payload = {
        page: 1,
        row: 100,
        series_id: val.series_id,
        hospital_id: this.hospital_id
      }
      const res = await this.getHistoryForTable(payload)
      if (res.status) return res.data
      else return []
    },
    // async setTimeOutRefeshBtn () {
    //   setTimeout(() => {
    //     this.init()
    //   }, 5500)
    // },
    // async setTimeOutRefeshBtn () {
    //   this.loading = true
    //   setTimeout(() => {
    //     this.refresh = false
    //   }, 3000)
    //   this.refresh = false
    //   // เมื่อ click refresh set
    //   this.countRefreshBtn = 0
    //   // getUploadBackground
    //   // TODO ดึงชื่อ servive name ทั้งหมด สำหรับเลือกโรคเพื่อ export
    //   const resSrv = await this.getServiceForDropdown()
    //   if (resSrv.status) {
    //     this.serviceName = resSrv.data.map((e) => e.name)
    //   } else {
    //     this.antmessage.error(resSrv.message)
    //   }
    //   setTimeout(async () => {
    //     // TODO เป็น Function ที่ใช้ในการ initial ข้อมูลที่จะเอามาใส่ในตราง
    //     const payload = {
    //       page: this.pagination.page,
    //       row: this.pagination.row,
    //       hospital_id: this.hospital_id,
    //       keyword: this.keyword,
    //       diagnosis: this.result === 'all' ? '' : this.result,
    //       start_date: !this.startDate
    //         ? ''
    //         : this.$moment(this.startDate).format('YYYY-MM-DD') + ' 00:00:00',
    //       end_date: !this.endDate
    //         ? ''
    //         : this.$moment(this.endDate).format('YYYY-MM-DD') + ' 23:59:59',
    //       time_zone: 'Asia/Bangkok',
    //       type: this.menuTabType
    //     }
    //     const res = await this.getHistoryForTable(payload)
    //     // console.log(res)
    //     this.loading = false
    //     if (res.status) {
    //       this.items = res.data.data
    //       // console.log(this.items)
    //       this.countTotolBox = res.data.pagination.total
    //       // console.log(this.items)
    //       this.pagination = res.data.pagination
    //     } else {
    //       this.antmessage.error(res.message)
    //     }
    //   })
    // },

    returnConsult (consultJob) {
      let listName = ''
      if (consultJob.length !== 0) {
        for (let index = 0; index < consultJob.length; index++) {
          listName =
            listName +
            consultJob[index].first_name +
            consultJob[index].last_name
          if (index + 1 !== consultJob.length) {
            listName = listName + ', '
          }
        }
        return listName
      } else {
        return '-'
      }
    },
    matchConsult (users = [], consultHospital = []) {
      const itemConsultOnly = []
      const arrayConsult = []
      for (let index = 0; index < users.length; index++) {
        for (let index1 = 0; index1 < consultHospital.length; index1++) {
          if (users[index] === consultHospital[index1].user_id) {
            arrayConsult.push(users[index])
            itemConsultOnly.push(consultHospital[index1])
          }
        }
      }
      this.consult = arrayConsult
      this.consultJob = itemConsultOnly
    },
    returnStatusWriteReview (reviews) {
      let status = false
      for (let index = 0; index < reviews.length; index++) {
        if (reviews[index].description !== '') {
          status = true
        }
      }
      return status
    },
    closeUpdateReview () {
      this.$swal({
        allowEnterKey: false,
        title: 'ยกเลิกการเขียนข้อเสนอแนะ',
        text: 'คุณต้องการยกเลิกการเขียนข้อเสนอแนะนี้ใช่หรือไม่',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'ตกลง'
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.disabledReview = true
          this.review = this.reviewOld
        }
      })
    },
    setReview (itemReview) {
      let status = 'add'
      for (let index = 0; index < itemReview.length; index++) {
        if (itemReview[index].create_by === this.userInfo.user_id) {
          status = 'edit'
          this.review = itemReview[index].description
          this.review_id = itemReview[index].review_id
        }
      }
      this.ststusReview = status
    },
    updateReview () {
      this.$swal({
        allowEnterKey: false,
        title: 'เขียนข้อเสนอแนะ',
        text: 'คุณต้องการบันทึกข้อเสนอแนะนี้ใช่หรือไม่',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'ตกลง'
      }).then(async (result) => {
        if (result.isConfirmed) {
          if (this.ststusReview === 'add') {
            this.loading = true
            const payload = {
              job_id: this.detailItem.job_id,
              description: this.review
            }
            const res = await this.createHistoryReview(payload)
            this.loading = false
            if (res.status) {
              this.$swal({
                allowEnterKey: false,
                title: 'สำเร็จ',
                text: 'บันทึกข้อเสนอแนะสำเร็จ',
                icon: 'success',
                showConfirmButton: false,
                showCancelButton: false,
                timer: 3000
              })
              this.init()
              this.disabledReview = true
              this.close()
            } else {
              this.antmessage.error(res.message)
            }
          } else if (this.ststusReview === 'edit') {
            this.loading = true
            const payload = {
              job_id: this.detailItem.job_id,
              review_id: this.review_id,
              description: this.review
            }
            const res = await this.updaeteHistoryReview(payload)
            this.loading = false
            if (res.status) {
              this.$swal({
                allowEnterKey: false,
                title: 'สำเร็จ',
                text: 'บันทึกข้อเสนอแนะสำเร็จ',
                icon: 'success',
                showConfirmButton: false,
                showCancelButton: false,
                timer: 3000
              })
              this.init()
              this.disabledReview = true
              this.close()
            } else {
              this.antmessage.error(res.message)
            }
          }
        }
      })
    },
    UpdaeteConsult () {
      this.$swal({
        allowEnterKey: false,
        title: 'ส่งconsult',
        text: 'คุณต้องการแก้ไขรายชื่อที่ส่ง consult ใช่หรือไม่',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'ตกลง'
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.loading = true
          const payload = {
            hospital_id: this.hospital_id,
            job_id: this.detailItem.job_id,
            user_id: this.consult
          }
          const res = await this.updaeteConsult(payload)
          this.loading = false
          if (res.status) {
            this.$swal({
              allowEnterKey: false,
              title: 'สำเร็จ',
              text: 'แก้ไขรายชื่อที่ส่ง consult สำเร็จ',
              icon: 'success',
              showConfirmButton: false,
              showCancelButton: false,
              timer: 3000
            })
            // ต้องแก้
            this.init()
            this.closeDialgConsult()
            this.close()
          } else {
            this.antmessage.error(res.message)
          }
        }
      })
    },
    closeDialgConsult () {
      this.dialogConsult = false
    },
    async initItemConsult () {
      this.loading = true
      const payload = {
        hospital_id: this.hospital_id,
        tag_name: 'consult'
      }
      const res = await this.getItemConsult(payload)
      this.loading = false
      if (res.status) {
        this.itemConsult = res.data
      } else {
        this.antmessage.error(res.message)
      }
    },
    async initHospitalStatus () {
      // this.loading = true
      const payload = {
        hospital_id: this.hospital_id,
        type: this.menuTabType
      }
      this.loadingSummaryBox = true
      const res = await this.getHospitalStatus(payload, this.menuTabType)
      this.loadingSummaryBox = false
      if (res.status) {
        this.itemSummary = res.data
      } else {
        this.antmessage.error(res.message)
      }
    },
    exportExcel () {
      this.$swal({
        allowEnterKey: false,
        title: 'ส่งออกเป็น Excel',
        text: 'คุณต้องการส่งออกประวัติการอัปโหลดเป็น Excel ใช่หรือไม่',
        icon: 'question',
        showCloseButton: true,
        showDenyButton: true,
        confirmButtonText: 'ตกลง',
        denyButtonText: 'ตั้งค่าเพิ่มเติม',
        denyButtonColor: '#848484'
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.loading = true
          const payload = {
            hospital_id: this.hospital_id,
            keyword: this.keyword,
            diagnosis: this.result === 'all' ? '' : this.result,
            start_date: !this.startDate
              ? ''
              : this.$moment(this.startDate).format('YYYY-MM-DD') + ' 00:00:00',
            end_date: !this.endDate
              ? ''
              : this.$moment(this.endDate).format('YYYY-MM-DD') + ' 23:59:59',
            time_zone: 'Asia/Bangkok'
          }
          await this.exportHistory(payload)
          this.loading = false
        }
        if (result.isDenied) {
          this.paginationExportTable.page = 1
          this.paginationExportTable.total = 0
          this.paginationExportTable.row = 10
          this.historyExportNew = Object.assign([])
          this.getHistoryExport()
        }
      })
    },
    async getHistoryExport () {
      this.dialogExport = true
      this.loadingExport = true
      this.historyExport = []
      // this.current++
      // paginationExportTable
      // this.paginationExportTable.page = 1
      // this.paginationExportTable.row = 10

      const payload = {
        // page: this.current,
        // row: this.increase,
        // FIX UKRIT 2024-07-06
        type: 'single',
        page: this.paginationExportTable.page,
        row: this.paginationExportTable.row,
        hospital_id: this.hospital_id,
        keyword: this.keyword,
        diagnosis: this.result === 'all' ? '' : this.result,
        start_date: !this.exportStartDate
          ? ''
          : this.$moment(this.exportStartDate).format('YYYY-MM-DD') +
            ' 00:00:00',
        end_date: !this.exportEndDate
          ? ''
          : this.$moment(this.exportEndDate).format('YYYY-MM-DD') + ' 23:59:59',
        time_zone: 'Asia/Bangkok'
      }
      const res = await this.getHistoryForTable(payload)
      if (res.status) {
        this.historyExport = this.historyExport.concat(res.data.data)
        this.historyExport = this.historyExport.map((element) => ({
          stateExport:
            this.historyExportNew.indexOf(element.items[0].job_id) > -1,
          ...element
        }))
        this.limit = res.data.pagination.total
        this.paginationExportTable.total = res.data.pagination.total
        this.paginationExportTable.page = res.data.pagination.page
      } else {
        this.antmessage.error(res.message)
      }
      this.loadingExport = false
    },
    onIntersect (entries) {
      if (
        entries[0].isIntersecting &&
        entries[0].target.id ===
          this.historyExport[this.historyExport.length - 1].job_id &&
        !this.loadingExport &&
        this.historyExport.length < this.limit
      ) {
        this.getHistoryExport()
      }
    },
    async mapJobIdForExportExcelAdvance () {
      // FIX กรองค่าที่ click
      const listOfselectedJobId = this.historyExport.filter(function (el) {
        return el.stateExport === true
      })
      const arrayJobId = []
      listOfselectedJobId.forEach((element) =>
        arrayJobId.push(element.items[0].job_id)
      )
      this.joinJobIdExport = arrayJobId.join(',')
      this.exportExcelAdvance()
    },
    async exportExcelAdvance () {
      this.loading = true
      const payload = {
        hospital_id: this.hospital_id,
        keyword: this.keyword,
        diagnosis: this.result === 'all' ? '' : this.result,
        start_date: !this.exportStartDate
          ? ''
          : this.$moment(this.exportStartDate).format('YYYY-MM-DD') +
            ' 00:00:00',
        end_date: !this.exportEndDate
          ? ''
          : this.$moment(this.exportEndDate).format('YYYY-MM-DD') + ' 23:59:59',
        time_zone: 'Asia/Bangkok',
        service_name: this.selectService.join(','),
        // job_id: this.joinJobIdExport
        job_id: this.historyExportNew.join(',')
      }
      await this.exportHistory(payload)
      this.loading = false
      this.dialogExport = false
    },
    openFormConsoult () {
      this.dialogConsult = true
    },
    statusNormal (processes) {
      let status = true
      for (let index = 0; index < processes.length; index++) {
        if (processes[index].results.length !== 0) {
          status = false
        }
      }
      return status
    },
    colorStatusIcon (status) {
      return status === true
        ? 'mdi-check-circle'
        : 'mdi-clock-time-four-outline'
    },
    colorStatusChip (status) {
      return status === true ? '#37C976' : '#FEA53F'
    },
    textStatusChip (status) {
      return status === true ? 'ยืนยันผลแล้ว' : 'รอยืนยันผล'
    },

    onChangePagination (val) {
      this.pagination.page = val.page
      this.pagination.row = val.row
      this.init()
    },
    onChangePaginationExport () {
      this.getHistoryExport()
    },
    async detailAll (item) {
      this.disabledReview = true
      this.consult = []
      this.itemConsult = []
      await this.initItemConsult()
      this.detailItem = await Object.assign({}, item)

      // set box image
      this.checkBoxDisease = await Object.assign({}, {})
      const checkBox = {}
      for (let index = 0; index < this.detailItem.processes.length; index++) {
        if (this.detailItem.processes[index].results.length !== 0) {
          checkBox[this.detailItem.processes[index].name] = [
            this.detailItem.processes[index].results[0]
          ]
        } else {
          checkBox[this.detailItem.processes[index].name] = []
        }
      }

      this.checkBoxDisease = Object.assign({}, checkBox)
      this.disease = await this.detailItem.processes[0]

      // ----match user consult
      this.matchConsult(this.detailItem.users, this.itemConsult)
      // set review edit or add
      this.setReview(this.detailItem.reviews)
      this.dialog = true
    },

    close () {
      // this.$refs.form.reset()
      // this.$refs.form.resetValidation()
      this.review = ''
      this.dialog = false
      this.stateProgressBar = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.disease = {}
      this.checkBoxDisease = {}
    },

    async openDialogViewer (val) {
      // TODO Clear Default Data
      this.itemViews = JSON.parse(JSON.stringify([]))
      // TODO Check Type Of Image is "series" or "single"
      // } else {
      // TODO Is "single" mode
      for (let i = 0; i < val.items.length; i++) {
        this.itemViews.push({
          job_id: val.items[i].job_id,
          po: val.items[i].resource.po,
          pn: val.items[i].resource.pn,
          da: val.items[i].resource.da,
          create_date: val.items[i].create_date,
          create_by: val.items[i].create_by,
          type: val.items[i].type,
          series_id: val.items[i].series_id,
          // src: val.resource.filename.file,
          src: this.imageUrl(val.items[i].resource.filename),
          processes: val.items[i].processes,
          adjusts: {
            brightness: 100,
            contrast: 100
          },
          comments: val.items[i].comments,
          dicom: this.dicomUrl(`${val.items[i].job_id}.dcm`)
        })
      }
      this.w = val.resource.width
      this.h = val.resource.height
      this.advanceDialog = true
    },

    // From Upload
    ...mapMutations(['addUploadBackground']),
    async CreateDataTable (val) {
      let tmp = val
      if (!this.statusUpload) {
        // TODO Clear Old file
        tmp = await tmp.filter((x) => {
          const i = this.tmpFiles.filter((y) => {
            // TODO เมื่อมีไฟล์อยู่แล้ว
            return y.id === x.id
          })
          // TODO หากว่ามี file return false
          return !(i.length > 0)
        })

        // TODO Reset State Upload
        this.files = tmp
        this.statusUpload = true
      }

      this.itemsForUpload = Object.assign([])
      // FIX UKRIT สำหรับส่วนจัดการ Item สำหรับทำ Progress
      if (this.type === 'single') {
        for (const item of tmp) {
          this.itemsForUpload.push({
            id: item.id,
            size: item.size,
            name: item.name,
            progress: 0
          })
        }
      } else if (this.type === 'series') {
        this.itemsForUpload.push({
          id: 0,
          name: `Upload ${this.files.length} file`,
          progress: 0,
          size: 0
        })
      }
      this.upload()
      // หลังจาก upload เสร็จ ปิด diglog
      this.dialogUploadXray = false
    },

    async initForUpload () {
      // NOTE Reset All Current State
      this.Reset()

      const payload = {
        hospital_id: this.hospital_id
      }

      const res = await this.getHospitalPackageForUpload(payload)
      // NOTE SUCCESS
      if (res.status) {
        this.allname = res.data.map((i) => {
          return {
            name: i.name,
            service_id: i.service_id
          }
        })
        this.diagnosisList = this.allname
      } else {
        // NOTE ERROR
        console.log(res)
      }
    },

    async upload () {
      this.statusUpload = false
      // this.series_id = ''
      if (this.type === 'series') {
        // this.series_id = uuid.v4()
        this.CreateMultiJobForUploadV2(
          this.hospital_id,
          this.diagnosisList,
          this.files,
          this.type,
          this.series_id
        )
      } else {
        this.CreateMultiJobForUpload(
          this.hospital_id,
          this.diagnosisList,
          this.files,
          this.type,
          this.series_id
        )
      }

      this.tmpItems = this.itemsForUpload
      this.tmpFiles = this.files
      this.addUploadBackground(this.tmpItems)
    },

    deleteItem (item) {
      this.files = this.files.filter((x) => x.id !== item.id)
      this.itemsForUpload = this.itemsForUpload.filter((x) => x.id !== item.id)
    },

    Reset () {
      this.itemsForUpload = Object.assign([])
      this.files = Object.assign([])
      this.statusUpload = true
      // this.allname = []
      // this.diagnosisList = []

      // this.selected = []
      // this.switch1 = false
      // this.wait = false
    },

    // new export
    changeListHistoryExport (item) {
      if (item.stateExport) {
        this.historyExportNew.push(item.items[0].job_id)
      } else {
        const index = this.historyExportNew.indexOf(item.items[0].job_id)
        if (index > -1) {
          this.historyExportNew.splice(index, 1)
        }
      }
    },
    clickExpandHistory () {
      this.expandHistory = !this.expandHistory
      if (this.expandHistory) {
        this.exportStartDate = this.$moment().format('YYYY-MM-DD')
        this.exportEndDate = this.$moment().format('YYYY-MM-DD')
        this.getHistoryExport()
      } else {
        this.historyExport = []
        this.historyExportNew = Object.assign([])
        setTimeout(() => {
          this.exportStartDate = ''
          this.exportEndDate = ''
        }, 500)
      }
    }
  }
}
</script>

<style lang="css" scoped>
.br {
  border: 2px solid red;
}
.layout-radio {
  margin-top: 0px !important;
  padding-top: 0px !important;
}
.title-card {
  font-size: 20px;
  font-weight: 300;
}
.detal-card {
  font-size: 18px;
  font-weight: 300;
}
.main-layout {
  height: 100%;
  position: relative;

  /* //edit */
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(5px);
  border-radius: 12px;
  padding: 12px;
}
.layout-content {
  height: 100%;
  padding: 0;
  margin: 0;
}
html.swal2-shown,
body.swal2-shown {
  overflow-y: hidden !important;
  height: auto !important;
}
/* //New UI */
.header-card {
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
}
.title-page {
  font-family: "Sarabun";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  /* Primary / #20409C */
  color: #20409c;
}
.counter-typetab-click {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 24px;
  background: #b2c6f8;
  border-radius: 16px;

  /* // text */
  font-weight: 500;
  font-size: 14px;
}

.counter-typetab-nonclick {
  display: flex;
  justify-content: center;
  align-items: center;
  /* // padding: 2px 8px; */
  width: 35px;
  height: 24px;
  background: #f2f2f2;
  border-radius: 16px;

  /* // text */
  font-weight: 500;
  font-size: 14px;
}

.btn-upload {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;

  max-width: 224px;
  width: 100%;
  height: 40px;
  background-color: #20409c;
  color: #ffffff;
  /* 02-Button Notification badges */
  box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.04),
    0px 2px 4px rgba(96, 97, 112, 0.16);
  border-radius: 20px;
}
::v-deep .btn-upload .v-btn__content {
  width: 100%;
  font-family: "Sarabun";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
}
.layout-total-box {
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-between; */
  margin-top: 16px;
  gap: 16px;
}
.total-box {
  /* //width: 349.33px;

  // width: 1/3; */
  /* width: 32%; */
  flex: 1;
  gap: 16px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 8px;
  padding-left: 8px;
  background: #ffffff;
  /* // border: 1px solid #20409C; */
  box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.04),
    0px 2px 4px rgba(96, 97, 112, 0.16);
  border-radius: 12px;

  /* 02 - Body / Medium / 16pt */
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  /* or 22px */
}
.size-img-box {
  display: flex;
  width: 40px;
  height: 40px;
}
.custom-btn-file-upload {
  /* Button */
  /* Auto layout */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 8px;

  width: 112.5px;
  height: 38px;
  background: #ffffff;
  box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.04),
    0px 2px 4px rgba(96, 97, 112, 0.16);
  border-radius: 20px;

  color: #20409c;
  cursor: pointer;
}
/* // .search-input {
//   width: 130px;
//   box-sizing: border-box;
//   border: 2px solid #ccc;
//   border-radius: 4px;
//   font-size: 16px;
//   background-color: white;
//   // background-image: url('searchicon.png');
//   background-position: 10px 10px;
//   background-repeat: no-repeat;
// } */

/* // .input-grey-rounded {
//   font-size: 16px;
//   line-height: 1.5;
//   background: #e9eef0;
//   border: 1px solid #d5d9db;
//   background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'><path fill='%238C92A0' d='M11.44 10.73l4.41 4.42a.5.5 0 1 1-.7.7l-4.42-4.41a6.5 6.5 0 1 1 .7-.7v-.01zM6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z'></path></svg>");
//   background-repeat: no-repeat;
//   background-position: 15px 10px;
//   // background-position: 50px right ;
//   background-size: 20px 20px;
//   border-radius: 100px;
//   // width: 300px;
//   max-width: 268px;
//   width: 100%;
//   padding: 0.5em 1em 0.5em 2.5em;
// } */
/*
// .input-grey-rounded::placeholder {
//   color: #838d99;
// }

// .input-grey-rounded:focus {
//   outline: none;
//   background-color: #fff;
//   border: 1px solid #84a2fa;
// }

//ความเร่งด่วนของเคส :
// ::v-deep .selectXrayCase .v-select__slot {
//   // background: #84A2FA;
//   // border: 1px solid #E6E6E6;
//   border: none;
//   border-radius: 32px;
//   color: #333333;
// }
// ::v-deep .selectXrayCase .v-input__slot{
//       align-items: center;
//     display: flex;
//     margin-bottom: 8px;
//     min-height: 40px;
//     position: relative;
//     transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
//     transition-property: height, min-height;
//     max-width: 158px;
//     width: 100%;
// }
// ::v-deep .selectXrayCase
//   .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
//   > .v-input__control
//   > .v-input__slot,
// .v-text-field.v-text-field--enclosed .v-text-field__details {
//   padding: 0px;
// }
// ::v-deep .theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
//   background: #ffffff;
//   border-radius: 32px;
//   border: 1px solid #e6e6e6;
// }
// ตัวกรอง ขั้นสูง */
.filter-text {
  display: flex;
  font-weight: 500;
  font-size: 16px;
  color: #20409c;
}
.width-btn {
  position: relative !important;
  max-width: 125px;
  max-height: 40px;
  height: 100%;
  border: 1px solid #20409c;
  border-radius: 20px;

  font-weight: 500;
  font-size: 16px;
}
.v-btn--disabled {
  border: none;
}
::v-deep .width-btn .v-btn__content {
  width: 100%;
  /* // text */
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  /* // color: #20409c; */
}
/* // ::v-deep .width-btn .v-btn {
//   width: 100%;
//   background: violet;
// } */

/* file x-ray form */
.UploadFileXrayCard {
  width: 100%;
  height: 100%;
  max-width: 1157px;
  max-height: 526px;
  padding: 16px;
  box-shadow: 0px 2px 4px rgba(40, 41, 61, 0.04),
    0px 8px 16px rgba(96, 97, 112, 0.16);
  border-radius: 12px;
}
.type-file-xray {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  padding-right: 10px;
  padding-left: 10px;
}

.type-xray-block {
  margin-right: 8px;
  margin-left: 8px;
  background: #ffffff;
  box-shadow: 0px 0px 2px rgba(40, 41, 61, 0.04),
    0px 4px 8px rgba(96, 97, 112, 0.16);
  border-radius: 12px;
}
/* // .type-xray-block:hover{
//   filter: blur(5px);
//   background: rgba(32, 64, 156, 0.6);
// } */
.type-xray-block-hover {
  opacity: 0.8;
  background: rgba(32, 64, 156, 0.6);
}
.icon-download {
  display: flex;
  justify-items: center;
  font-size: 100px;
  color: white !important;
}

/* //เลือกประเภทไฟล์ x-ray */
.title-fileXrayBox {
  padding-top: 16px;
  padding-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  font-weight: 700;
  font-size: 20px;
  color: #333333;
}
input[type="file"] {
  display: none;
}
.custom-file-upload {
  display: flex;
  flex-direction: row;
  border: 1px solid inherit;
  border-radius: 0.5rem;
  background: none;
  color: #fff;
}
.color-btn-expor-refresh {
  color: #20409c;
}
.section-three {
  display: flex;
}
/* For paginationExportTable */
.row-per-page {
  /* background: pink; */
  max-width: 60px !important;
  white-space: nowrap;
  text-align: center;
}

::v-deep .row-per-page .v-select__slot .v-select__selection {
  /* color: red !important; */
  font-weight: 200;
  font-size: 12px;
}
::v-deep .row-per-page .v-select__slot .v-select__selections input {
  /* color: red !important; */
  display: none !important;
}

::v-deep .row-per-page .v-select__slot .v-input__append-inner {
  padding-top: 4px;
}
.pagination-text {
  font-weight: 200;
  font-size: 12px;
}
@media only screen and (max-width: 982px) {
  .total-box {
    /* //width: 349.33px;
    // width: 1/3; */
    width: 50%;
    height: 72px;
    margin-top: 10px;
  }
  .main-layout {
    height: 100%;
    overflow-y: scroll;
    overflow-x: auto;
  }
  .header-card {
    display: flex;
    flex-direction: column;
  }
  .title-page {
    margin-bottom: 10px;
  }
}
@media only screen and (max-width: 734px) {
  .type-file-xray {
    display: flex;
    flex-direction: column;
  }
}
@media only screen and (max-width: 600px) {
  .total-box {
    /* //width: 349.33px;
    // width: 1/3; */
    width: 100%;
    height: 62px;
  }
  .section-three {
    display: flex;
    flex-direction: column;
  }
}
</style>
